import { useEffect, useState, useRef } from 'react';

import useResize from 'js/hooks/use-resize';

const useContentHeight = () => {
  const [height, setHeight] = useState<string>('0px');
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) setHeight(`${contentRef.current.offsetHeight}px`);
  }, []);

  useResize(() => contentRef.current && setHeight(`${contentRef.current.offsetHeight}px`));

  return { height, contentRef };
};

export default useContentHeight;
